<div class="wrapper" :class="site">
    <theader></theader>
    <main>
        <router-view/>
    </main>
    <tfooter></tfooter>
</div>



// WEBPACK FOOTER //
// ./src/components/pages/page.tpl.html